import { useEffect, useState } from "react";
import clientsApi from "../../api/client/client";
import trainingCategoryApi from "../../api/trainingCategory/trainingCategory";
import { ui } from "../../helpers/ui";

const InitInactiveClientsLogic = () => {
  const [clients, setClients] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>([]);

  const loadClients = () => {
    clientsApi
      .findInactive()
      .then((response) => {
        if (response.status === 200) {
          setClients(response.data);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const loadCategories = () => {
    trainingCategoryApi
      .getAll()
      .then((response) => {
        if (response.status === 200) {
          setCategories(response.data);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  useEffect(() => {
    loadClients();
    loadCategories();
  }, []);

  return {
    clients,
    categories,
  };
};

export default InitInactiveClientsLogic;
